export const OVERLAY_DURATION_S = 1.1;
export const TRANSITION_EASING: [number, number, number, number] = [0.22, 1, 0.36, 1];
export const OVERLAY_Z_INDEX = 1500;
export const BELOW_DESKTOP_MQ = '@media (max-width:1023.95px)';
export const BELOW_TABLET_MQ = '@media (max-width:767.95px)';
export const DESKTOP_UP_MQ = '@media (min-width:1024px)';
export const MOBILE_TOP_INSET_PX = 200;
export const DESKTOP_CONTENT_HORIZONTAL_PX = 16;
export const DEFAULT_TITLE = 'Willkommen bei Tischler NRW';
